module.exports = __webpack_public_path__ + "Typedepot---CentraleSansXBold.6655b81cfb7da51da97e.otf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/Typedepot---CentraleSansXBold.otf
// module id = ../../../../../src/assets/fonts/Typedepot---CentraleSansXBold.otf
// module chunks = styles